import React from "react";
import { withTranslation } from 'react-i18next';
import {
  registerQuickAddAutoComplete,
  quickAddEventHandler,
  removeEmojiContent,
  getUserId,
  getWsTagId
} from "../../utils/common";

import CommonTags, {
  autoResizeTextArea,
  resetTextAreaHeight
} from "./commonTags";

import ListenerComponent from './listenerComponent';
import { nowToUnix } from "../../apps/meetings/utils/dates";

//  Empty Takeaway Textarea Section
class MeetingTakeawaySection extends ListenerComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      type: "take",
      tag: 0,
      act: "add",
      showDoneBtn: 0,
      emptyArea: this.props.emptyArea ? this.props.emptyArea : false,
      removeCKEditorFlag: 0,
      pointerEvents: 'unset',
      handleClickOutsideFlag: true,
    };
    this.saveTakeText = this.saveTakeText.bind(this);
    this.addAiTake = this.addAiTake.bind(this);
    this.submitTake = this.submitTake.bind(this);
    this.afterSaveTake = this.afterSaveTake.bind(this);
    this.takeawayLiveSync = this.takeawayLiveSync.bind(this);
    this.openTextArea = this.openTextArea.bind(this);
    this.closeTextArea = this.closeTextArea.bind(this);
    this.getReturnTag = this.getReturnTag.bind(this);
    this.wrapperRef = React.createRef();
    this.meeting_take = React.createRef();
    this.handleCloseWindow = this.handleCloseWindow.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    this.showBox = false;
    const { userPermission, meetingObj, topicRelId = "" } = this.props;
    if (
      typeof userPermission.execute !== "undefined" &&
      userPermission.execute == "1"
    ) {
      const _id = `#meeting_take_${meetingObj.id}${topicRelId != "" ? `_${topicRelId}` : ""
        }`;
      registerQuickAddAutoComplete(_id);
    }

    const eleId = `meeting_take_${this.props.meetingObj.id}${this.props.topicRelId != "" ? `_${this.props.topicRelId}` : ""
      }`;

    // window.addEventListener("mouseup", this.saveTakeText, true);

    document.addEventListener('mousedown', this.handleClickOutside);
    window.addEventListener('pushState', this.handleGlobalStateChange);
  }

  componentWillUnmount() {
    window.removeEventListener('mouseup', this.saveTakeText, true);
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('pushState', this.handleGlobalStateChange);
    if (this.state.removeCKEditorFlag == 1) {
      this.setState({
        removeCKEditorFlag: 0
      })
    }
  }

  handleCloseWindow(e) {
    const { meetingObj, topicRelId } = this.props;

    let eleId = `meeting_take_${meetingObj.id}`

    if (topicRelId) {
      eleId += `_${topicRelId}`
    }

    const takeawayCKEditorInputValue = $(`#cke_${eleId} iframe`).contents().find('body').html()
    const text = $(takeawayCKEditorInputValue).text().trim()

    if (text.length > 0) {
      e.preventDefault()
      e.returnValue = ''
    }
  }

  handleClickOutside(e) {
    const { meetingObj, topicRelId } = this.props;

    const targetClassList = e.target.classList
    const clickedOnTooltip = targetClassList.contains('ui-tooltip-content') || targetClassList.contains('ui-tooltip')

    let id = `meeting_take_${meetingObj.id}`
    if (topicRelId) {
      id += `_${topicRelId}`
    }
    const linkPopup = $(`.cke_editor_${id}_dialog`);
    const submitButtonCheck = ($(`#cke_${id}`).length > 0 || $(`#${id}`).text() != '') && !e.target.parentElement.classList.contains('subTakeBtn')

    if (
      submitButtonCheck
      && this.wrapperRef
      && !this.wrapperRef.current.contains(e.target)
      && (linkPopup.length == 0 || (linkPopup.length > 0 && linkPopup.css('display') == 'none'))
      && !clickedOnTooltip
      && this.state.handleClickOutsideFlag
    ) {
      this.saveTakeText(e);
      if ($('.mention-suggestions').length > 0 && $(e.currentTarget.activeElement).parents('.cke').length < 1) {
        $('.mention-suggestions').remove();
        $('.mention-suggestions-div').remove();
      }
    }
  }

  getEleId = () => {
    const eleId = `meeting_take_${this.props.meetingObj.id}${this.props.topicRelId != "" ? `_${this.props.topicRelId}` : ""
      }`;
    return eleId;
  }

  saveTakeText(e) {
    this.setState({
      pointerEvents: 'none'
    })
    const empTakeContainer = $(
      `#meeting_take_${this.props.meetingObj.id}${this.props.topicRelId != "" ? `_${this.props.topicRelId}` : ""
      }`
    );
    let ckEditorFlag = !$(empTakeContainer).is(e.target) &&
      $(empTakeContainer).has(e.target).length === 0;
    let takeawayCKEditorInput = $(`#cke_meeting_take_${this.props.meetingObj.id}${this.props.topicRelId != "" ? `_${this.props.topicRelId}` : ""}`);
    if (takeawayCKEditorInput != undefined) {
      let takeawayCKEditorInputValue = $(`#cke_meeting_take_${this.props.meetingObj.id}${this.props.topicRelId != "" ? `_${this.props.topicRelId}` : ""
        }` + ' iframe').contents().find('body').html();
      if ($(takeawayCKEditorInputValue).text() == '') {
        takeawayCKEditorInputValue = '';
      }
      empTakeContainer.val(takeawayCKEditorInputValue);
      ckEditorFlag = !$(takeawayCKEditorInput).is(e.target) &&
        $(takeawayCKEditorInput).has(e.target).length === 0;
    }
    const agendaSearchContainer = $(".agenda-autosearch");
    const tagListContainer = $(".meeting-tag-wrapper");
    let takeText = "";

    // adding a more reliable way to track click vs drag (mousedown/mouseup)
    let highlightedText = "";
    if (window.getSelection) {
      highlightedText = window.getSelection().toString();
    } else if (document.selection && document.selection.type != "Control") {
      highlightedText = document.selection.createRange().text;
    }
    if (highlightedText != "") {
      return;
    } else {
      if (
        ckEditorFlag &&
        (!$(agendaSearchContainer).is(e.target) &&
          $(agendaSearchContainer).has(e.target).length === 0) &&
        (!$(tagListContainer).is(e.target) &&
          $(tagListContainer).has(e.target).length === 0)
      ) {
        const fieldObj = $(this.meeting_take);
        takeText = $.trim(fieldObj[0].current.value);

        const eleId = this.getEleId();
        let mainText = "";
        if (eleId) {
          let insta = CKEDITOR.instances[eleId];
          if (insta) {
            mainText = removeEmojiContent(CKEDITOR.instances[eleId].getData().trim());
          }
        }
        if (
          mainText
            .trim().length == 0 || $('#cke_' + eleId + ' iframe').contents().find('body').text() == ''
        ) {
          this.afterSaveTake();
          return;
        }
        const tag = this.meeting_take.current.getAttribute("data-tag");
        this.submitTake(takeText, tag);
      } else if (empTakeContainer.parents(".meeting_take_sortable").length) {
        empTakeContainer
          .parents(".meeting_take_sortable")
          .removeClass("bgwhite");
        if (typeof eleId != 'undefined' && eleId) {
          destroyMeetingEditor(eleId);
        }
      }
    }
  }

  addAiTake(el) {
    const fieldObj = $(this.meeting_take);
    const takeText = $.trim($(fieldObj).html());
    if (
      $(fieldObj)
        .text()
        .trim().length == 0
    ) {
      return;
    }
    const quickAddAI = $(fieldObj).data("quickAddAI");
    if (
      ((el.keyCode == 13 && quickAddAI == true) ||
        ((el.ctrlKey || el.metaKey) && el.keyCode == 83)) &&
      takeText != ""
    ) {
      const tag = $(el.target)
        .closest(".meeting-take-sec")
        .find(".meeting-tag-options")
        .attr("data-tag");
      el.preventDefault();
      this.submitTake(takeText, tag);
    }
  }

  submitTake(takeText, tag, updatedS3Data) {
    const { actions } = this.props;
    const { meetingObj } = this.props;
    const meetingId = meetingObj.id;
    const { currentUser } = this.props;
    const fname = currentUser.firstname;
    const lname = currentUser.lastname;
    const topicRelId =
      this.props.topicRelId != ""
        ? this.props.topicRelId
        : this.props.takeTopicId;
    const fieldObj = $(this.meeting_take);
    let quickAddAI = true; //$(fieldObj).data("quickAddAI");
    const eleId = `meeting_take_${meetingObj.id}${topicRelId != "" ? `_${topicRelId}` : ""
      }`;
    const { takeTopicId } = this.props;
    var tag = tag;
    let fromTopicAdd = false;

    if (
      quickAddAI == true &&
      !takeText.match(/#(.*)#/) &&
      !takeText.match(/@(.*)@/) &&
      !takeText.match(/(\!)(\d)+(\?)*/g)
    ) {
      quickAddAI = false;
    }

    if (quickAddAI == true && takeText.match(/@(.*)@/) && !takeText.match('data-userid')) {
      quickAddAI = false;
    }
    if (quickAddAI == true && takeText.match(/#(.*)#/) && !takeText.match('data-quickaddtagid')) {
      quickAddAI = false;
    }

    if (updatedS3Data) {
      actions.UpdateMeetingS3Data("mtS3Data", updatedS3Data);
    }

    let rowIndex = 0;
    if (topicRelId != "") {
      const divRelCount = $(`.relTopicTakeList_${topicRelId}`).length;
      if (divRelCount == 0) {
        rowIndex = rowIndex;
      } else {
        rowIndex = divRelCount;
      }
    } else {
      const divNonCount = $(".meetingTopicTakeDetails").length;
      if (divNonCount == 0) {
        rowIndex = rowIndex;
      } else {
        $(".meetingTopicTakeDetails").each(function () {
          rowIndex = Math.max($(this).attr("data-pos"), rowIndex);
        });
        rowIndex += 1;
      }
    }
    takeText = removeEmojiContent(takeText);
    if (takeText == '' || takeText == null || typeof takeText === 'undefined') {
      return;
    }
    const quickAddAIParams = {};
    const meetingWsId = meetingObj.ws_id;
    if (quickAddAI == true) {
      const isvalid = quickAddEventHandler(fieldObj);
      if (!isvalid) {
        return;
      }
      quickAddAIParams.tagId = takeText.match(/#(.*)#/)
        ? getWsTagId(takeText)
        : "";
      if (
        quickAddAIParams.tagId == "" ||
        typeof quickAddAIParams.tagId === "undefined"
      ) {
        quickAddAIParams.tagId = meetingWsId;
      }
      quickAddAIParams.userId = takeText.match(/@(.*)@/)
        ? getUserId(takeText)
        : "";
    }
    if (takeTopicId != "") {
      const filesTopicObj = $(`#meeting_topic_${meetingId}`);
      $.trim($(filesTopicObj).html(""));
      resetTextAreaHeight({ eleId: `#meeting_topic_${meetingId}` });
      fromTopicAdd = true;
    }
    const elementId = this.getEleId();
    this.props.clearGlobalValueBta();
    this.showBox = false;
    $.trim($(fieldObj).html(""));
    this.setState({ handleClickOutsideFlag: false }, () => {
      if (topicRelId != "") {
        this.props.saveMeetingTakeAway(
          takeText,
          meetingId,
          tag,
          nowToUnix(),
          fname,
          lname,
          topicRelId,
          quickAddAI,
          quickAddAIParams,
          this.afterSaveTake,
          fromTopicAdd
        );
      } else {
        this.props.saveMeetingNullTopicNote(
          takeText,
          meetingId,
          tag,
          nowToUnix(),
          fname,
          lname,
          topicRelId,
          quickAddAI,
          quickAddAIParams,
          this.afterSaveTake
        );
        if (typeof elementId != 'undefined' && elementId) {
          destroyMeetingEditor(elementId);
        }
      }
    });
  }

  afterSaveTake(takeId, takeDesc) {
    this.setState({
      tag: 0,
      showDoneBtn: 0,
      pointerEvents: 'unset',
      handleClickOutsideFlag: true
    });
    const eleId = this.getEleId();
    this.removeCKEditorTakeaway(eleId);
    this.closeTextArea();
  }

  takeawayLiveSync() {
    // Notify typing event
    if (!getMeetingTyping()) {
      typing("meet");
      setMeetingTyping(true);
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        typingTimeOut("meet");
      }, 3500);
    }
    // if user is typing and both the users are active in meeting, then display the warning
    if ($("#typing-alert").css("display") == "none") {
      // element is hidden
      $(".topic-alert")
        .delay(100)
        .fadeOut();
    } else {
      $(".topic-alert")
        .delay(500)
        .fadeIn();
    }

    const eleId = this.getEleId();
    autoResizeTextArea({ eleId: `#${eleId}` });
  }

  openTextArea(e) {
    this.showBox = true;
    const _this = this;
    const eleId = this.getEleId();
    const tag = $(e.target)
      .closest(".meeting-take-sec")
      .find(".meeting-tag-options")
      .attr("data-tag");
    _this.setState({
      tag,
      showDoneBtn: 1,
      removeCKEditorFlag: 1,
    });
    if (typeof eleId != 'undefined' && eleId) {
      initializeMeetingEditor(eleId, this.saveTakeText);
    }
    autoResizeTextArea({ eleId: `#${eleId}` });

    if ($(`#${eleId}`).parents(".meeting_take_sortable").length) {
      $(`#${eleId}`)
        .parents(".meeting_take_sortable")
        .addClass("bgwhite");
    }
    if (this.props.takeTopicId != "") {
      this.props.clearGlobalValue();
    }

    window.addEventListener('beforeunload', this.handleCloseWindow)
  }

  closeTextArea() {
    const { topicRelId = "", topicTakeCount = 0 } = this.props;
    this.showBox = false;
    const eleId = this.getEleId();
    resetTextAreaHeight({ eleId: `#${eleId}` });
    const _this = this;
    _this.setState({
      tag: 0,
      showDoneBtn: 0
    });
    $(_this.meeting_take).val("");
    if (topicRelId && topicTakeCount) {
      if (typeof this.props.hideShowBox === "function") {
        this.props.hideShowBox(topicRelId);
      }
    }
    if ($(`#${eleId}`).parents(".meeting_take_sortable").length) {
      $(`#${eleId}`)
        .parents(".meeting_take_sortable")
        .removeClass("bgwhite");
    }
  }

  getReturnTag(tagId) {
    this.setState({
      tag: tagId
    });
  }

  removeCKEditorTakeaway = (eleId) => {
    destroyMeetingEditor(eleId);

    window.removeEventListener('beforeunload', this.handleCloseWindow)
  }

  render() {
    const { meetingObj, t } = this.props;
    const { currentUser } = this.props;
    const { topicRelId } = this.props;
    const enDivHeight = this.state.enablePost ? "paddT5" : "";
    const enSecondHeight = this.state.enablePost ? "enDivHeight" : "";
    const enAreaHeight = this.state.enablePost ? "emtextArea" : "";
    const textareaId = `meeting_take_${meetingObj.id}${topicRelId != "" ? `_${topicRelId}` : ""
      }`;
    const emptyNoteArea = topicRelId == "" ? "meetingagendatextboxempty" : "";
    setTimeout(() => {
      $(`#${textareaId}`).removeProp("disabled");
      $(`#${textareaId}`).removeAttr("disabled");
    }, 500);
    return (
      <div
        className={`takeawayHead  ${topicRelId != "" ? "placeholderText" : "displayCell"
          }`}
        style={{ minHeight: topicRelId != "" ? "50px" : "40px" }}
      >
        <div className="oneonone-expand ">
          <div className={`wb-textarea-container ${topicRelId == "" ? "addTakeawayContainer" : ""
            }`} ref={this.wrapperRef}>
            <div className={`type-enter-box ${enSecondHeight}`}>
              <div className={`width100 meeting-take-sec ${enDivHeight} takeawayyContainer`} >
                <CommonTags
                  owner={currentUser.id}
                  key={`topic_take_${topicRelId}`}
                  meeting={meetingObj}
                  userPermission={this.props.userPermission}
                  currentUser={currentUser}
                  tag={this.state.tag}
                  type={this.state.type}
                  act={this.state.act}
                  saveTags={this.props.saveTags}
                  getReturnTag={this.getReturnTag}
                  emptyArea={this.state.emptyArea}
                />
                <div
                  // contentEditable={meetingObj.status != "1" ? "" : "true"}
                  className={`meetingagendatextbox meetingTakeNote ${enAreaHeight}${emptyNoteArea}`}
                  ref={this.meeting_take}
                  placeholder={topicRelId != "" ? "" : t("Add takeaways here")}
                  id={textareaId}
                  data-enable-quickadd="true"
                  data-tag={this.state.tag}
                  onKeyDown={!this.state.isSomethingPending ? event => this.addAiTake(event) : null}
                  style={{ width: "88%", paddingLeft: '60px' }}
                  onKeyPress={!this.state.isSomethingPending ? event => this.takeawayLiveSync() : null}
                  onFocus={!this.state.isSomethingPending ? e => this.openTextArea(e) : null}
                  onClick={!this.state.isSomethingPending ? e => this.openTextArea(e, this.state.tag) : null}
                  data-attr-takeaway="true"
                />

              </div>
            </div>
            {this.state.showDoneBtn ? (
              <button
                onClick={!this.state.isSomethingPending ? e => this.saveTakeText(e) : null}
                className="btn-circle subTakeBtn"
                disabled={this.state.isSomethingPending}
                style={{ marginTop: "-41px", pointerEvents: this.state.pointerEvents }}
              >
                <span className="icon icon-outline-check-24px-blue"></span>
              </button>
            ) : (
              ""
            )}
          </div>
        </div>

      </div>
    );
  }
}
export default withTranslation()(MeetingTakeawaySection);
